/* eslint-disable */
import React from 'react'
import { scaleLinear } from 'd3-scale'
import { max } from 'd3-array'
import groupBy from 'lodash/groupBy'
import { arc, pie } from 'd3-shape'
import { RemoveBadPitchPoints } from '../../Utilities/RemoveBadPoints'
import Color from '../../Utilities/Colors/ColorMap'
import PieLegend from '../../Legend/PieLegend'
import Legend from '../../Legend/Legend'

export default function Pitches({ settings, chartOptions = {} }) {
    const { pitcherPerspective, scaleRadius } = chartOptions

    const pitchData = groupPitchesAndLocation(settings.data)

    const pitches = groupBy(pitchData, 'pzpx')

    let radius = 15

    let radiusScale
    if (scaleRadius) {
        const maxes = []
        for (const zone in pitches) {
            let count = 0
            for (let i = 0; i < pitches[zone].length; i++) {
                count += Number(pitches[zone][i].count)
            }
            maxes.push(count)
        }
        const maxValue = max(maxes, (d) => Number(d))

        radiusScale = scaleLinear()
            .range([settings.vizWidth * 0.025, settings.vizWidth * 0.045])
            .domain([1, maxValue])
    }

    const x = scaleLinear()
        .range([0, settings.vizWidth])
        .domain(pitcherPerspective ? [4, -4] : [-4, 4])
    const y = scaleLinear().range([settings.vizHeight, 0]).domain([-1, 6])

    const pitchPie = []

    for (var pitch in pitches) {
        let size = 0
        for (let i = 0; i < pitches[pitch].length; i++) {
            size += Number(pitches[pitch][i].count)
        }

        if (scaleRadius) {
            radius = radiusScale(size)
        }

        const pp = pie()
            .sort(null)
            .value((d) => Number(d.count))

        const path = arc()
            .outerRadius(radius - settings.vizWidth * 0.014)
            .innerRadius(0)

        pitchPie.push(
            pp(pitches[pitch]).map((d, i) => (
                <g
                    key={`pie_key_${pitch}_${d.data.count}_${i}`}
                    id={`id_${pitch}_${d.data.count}`}
                >
                    <path
                        transform={`translate(${x(d.data.px)},${y(d.data.pz)})`}
                        d={path(d)}
                        fill={Color('pitch_name', d.data.pitch)}
                        stroke="#000"
                        strokeWidth={0.5}
                    />
                </g>
            ))
        )
    }
    return (
        <>
            <g id="pitchPie">{pitchPie}</g>
            {chartOptions.legend ? (
                <>
                    <Legend settings={settings} type="pitchName" />
                    {scaleRadius ? (
                        <PieLegend
                            settings={settings}
                            radiusScale={radiusScale}
                        />
                    ) : null}
                </>
            ) : null}
        </>
    )
}

const BIN_SIZE = 0.5
function roundAndGroupPitches(pitches) {
    for (let i = 0; i < pitches.length; i++) {
        const pitch = pitches[i]
        pitch.piePx = (
            Math.round(Number(pitch.x) / BIN_SIZE, 0) * BIN_SIZE
        ).toFixed(2)
        pitch.piePz = (
            Math.round(Number(pitch.y) / BIN_SIZE, 0) * BIN_SIZE
        ).toFixed(2)

        pitch.pieId = `p_${
            pitch.piePz < 0 ? `_${Math.abs(pitch.piePz)}` : pitch.piePz
        }${pitch.piePx < 0 ? `_${Math.abs(pitch.piePx)}` : pitch.piePx}`
        pitch.pieId = pitch.pieId.split('.').join('')
    }
    // return groupPitchesAndLocation(pitches);
    return pitches
}

function groupPitchesAndLocation(pitches) {
    //  const pitches = removeBadPitches
    pitches = roundAndGroupPitches(pitches)

    const pitchLocations = groupBy(pitches, (d) => d.pieId)

    const pitchBreakdown = []
    for (const location in pitchLocations) {
        const l = pitchLocations[location]

        const pitchTypes = groupBy(l, (d) => d.pitchType)

        for (const pitchType in pitchTypes) {
            const p = pitchTypes[pitchType]
            pitchBreakdown.push({
                count: p.length,
                px: p[0].piePx,
                pz: p[0].piePz,
                pzpx: p[0].pieId,
                pitch: pitchType,
            })
        }
    }

    return pitchBreakdown
}
